import { Injectable } from '@angular/core';

import { IToastConfig } from '../interfaces';
import { DomService } from '../../services/dom.service';
import { ToastColorEnum, ToastPositionEnum } from '../enums';
import { ToastComponent } from '../components/toast.component';

@Injectable({
    providedIn: 'root',
})

export class ToastService {
    private count = 0;

    constructor(
        private readonly domService: DomService,
    ) {}

    public open(config: IToastConfig): ToastComponent {
        const componentRef = this.getComponentRef(config);

        this.count++;

        return componentRef.instance;
    }

    private getComponentRef(config: IToastConfig) {
        const componentRef = this.domService.attachComponentPortal(ToastComponent);

        config = Object.assign(
            {
                count: this.count,
                dismiss: () => this.count--,
                duration: config.color === ToastColorEnum.danger ? 10000 : 5000,
                position: ToastPositionEnum.right
            },
            config
        );

        (componentRef.instance as any).config = config;
        (componentRef.instance as any).afterClosed().subscribe(() => componentRef.destroy());

        return componentRef;
    }
}
